import { sendMessage } from "@microsoft/signalr/dist/esm/Utils";
import { get } from "react-hook-form";

const baseUrl = "/v1/provider";

export const endPoints = {
  //AddOnCategory
  addOnCategory: {
    create: "/v1/admin/addoncategory/create",
    getAll: "/v1/admin/addoncategory/get-all",
    update: "/v1/admin/addoncategory/update",
    delete: "/v1/admin/addoncategory/delete",
    dropdown: "/v1/admin/addoncategory/dropdown",
  },
   //Dashboard
  dashboard: {
    getStatistics: `${baseUrl}/dashboard/get-statistics`,
  },
  //Auth
  auth: {
    login: `${baseUrl}/auth/send-login-otp`,
    verifyOTP: `${baseUrl}/auth/verify-otp`,
    refreshToken: `${baseUrl}/auth/refresh-token`,
  },
  //Country
  country: {
    dropdown: "/v1/admin/country/dropdown",
  },
  //City
  city: {
    dropdown: "/v1/admin/city/dropdown",
    dropdownByCountry: "/v1/admin/city/dropdown",
    getAll: "/v1/admin/city/get-all",
    getAllSearch: "/v1/admin/city/get-all-search",
    toggleActivate: "/v1/admin/city/toggle-activate",
    create: "/v1/admin/city",
    update: "/v1/admin/city/update",
    edit: "/v1/admin/city/edit",
    deleteImage: "/v1/admin/city/delete-image",
    delete: "/v1/admin/city",
    getDetails: "/v1/admin/city/get-details",
  },
  //Category
  category: {
    dropdown: "/v1/admin/category/dropdown",
    getAll: "/v1/admin/category/get-all",
    getAllSearch: "/v1/admin/category/get-all-search",
    toggleActivate: "/v1/admin/category/toggle-activate",
    create: "/v1/admin/category",
    update: "/v1/admin/category/update",
    edit: "/v1/admin/category/edit",
    deleteImage: "/v1/admin/category/delete-image",
    delete: "/v1/admin/category",
    getDetails: "/v1/admin/category/get-details",
  },
  //Banner
  banner: {
    getAll: "/v1/admin/banner/get-all",
    getAllSearch: "/v1/admin/banner/get-all-search",
    create: "/v1/admin/banner",
    update: "/v1/admin/banner/update",
    edit: "/v1/admin/banner/edit",
    deleteImage: "/v1/admin/banner/delete-image",
    delete: "/v1/admin/banner",
    getDetails: "/v1/admin/banner/get-details",
  },
  //User
  user: {
    getProviderDropdown: "/v1/admin/User/get-provider-dropdown",
  },
  //Trip
  trip: {
    getAll:`${baseUrl}/Trip/get-all`,
    getAllSearch: `${baseUrl}/Trip/get-all-search`,
    create: `${baseUrl}/Trip/create`,
    update: `${baseUrl}/Trip/update`,
    edit:`${baseUrl}/Trip/edit`,
    deleteImage:`${baseUrl}/Trip/delete-image`,
    toggleActivate:`${baseUrl}/Trip/toggle-activate`,
    getDetail: `${baseUrl}/Trip/get-detail`,
    delete: `${baseUrl}/Trip/delete`,
    getDropdown: `${baseUrl}/Trip/get-dropdown`,
    getTripUnavailableDates:`${baseUrl}/Trip`,
  },
  //Trip Unavailable Date
  tripUnavailableDate: {
    get: "/v1/admin/tripunavailabledate",
    create: "/v1/admin/tripunavailabledate",
    delete: "/v1/admin/tripunavailabledate",
  },
  //Trip Video
  tripVideo: {
    create: "/v1/admin/tripvideo",
    delete: "/v1/admin/tripvideo",
  },
  //Package
  package: {
    getTripPackages: "/v1/admin/package/get-trip-packages",
  },
  //Provider
  provider: {
    getAll: "/v1/admin/Provider/get-all",
    getAllSearch: "/v1/admin/Provider/get-all-search",
    create: "/v1/admin/Provider/create",
    update: "/v1/admin/Provider/update",
    edit: "/v1/admin/Provider/edit",
    toggleActivate: "/v1/admin/Provider/toggle-activate",
    getDetail: "/v1/admin/Provider/get-detail",
    delete: "/v1/admin/Provider/delete",
    deleteImage: "/v1/admin/Provider/delete-image",
  },
// Customer
customer: {
  dropdown: "/v1/admin/Customer/dropdown",
  getAll: "/v1/admin/Customer/get-all",
  getAllSearch: "/v1/admin/Customer/get-all-search",
  create: "/v1/admin/Customer/create",
  edit: "/v1/admin/Customer/edit",
  getDetail: "/v1/admin/Customer/get-detail",
  update: "/v1/admin/Customer/update",
  deleteImage: "/v1/admin/Customer/delete-image",
  delete: "/v1/admin/Customer/delete",
  toggleActivate: "/v1/admin/Customer/toggle-activate",
},
  //Notification
  notification: {
    getAll: `${baseUrl}/Notification/get-all`,
    getAllSearch: `${baseUrl}/Notification/get-all-search`,
    getDetail: `${baseUrl}/Notification/get-detail`,
    markAsRead: `${baseUrl}/Notification/mark-as-read`,
    unreadCount: `${baseUrl}/Notification/unread-count`,
    // edit: "/v1/admin/Notification/edit",
    // create: "/v1/admin/Notification/create",
    // update: "/v1/admin/Notification/update",
    // delete: "/v1/admin/Notification/delete",
  },
  //Booking
  booking: {
    getAll:`${baseUrl}/Booking/get-all`,
    getAllSearch:`${baseUrl}/Booking/get-all-search`,
    updateStatus:`${baseUrl}/Booking`,
    create: `${baseUrl}/Booking`,
    edit: `${baseUrl}/Booking/edit`,
    update: `${baseUrl}/Booking`,
    getDetail: `${baseUrl}/Booking`,
  },
  //Bank
  bank: {
    dropdown: "/v1/admin/bank/dropdown",
  },
   //Transaction
  transaction: {
    getAll: `${baseUrl}/Transaction/get-all`,
    getAllSearch: `${baseUrl}/Transaction/get-all-search`,
  },
   //chat
  chat: {
    getConversations: "/v1/admin/chat/get-conversations",
    getMessages: "/v1/admin/chat/get-messages",
    readMessages: "/v1/admin/chat/read-messages",
    sendMessage: "/v1/admin/chat",
  },
  // Add more endpoints as needed
};
